import { Component, ChangeDetectorRef } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { AppService } from '../../services/app.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UtilsService } from '../../services/utils.service';
import { isEqual } from 'lodash';
import { SharedService, SlidesService } from '../../services';
import { SlidesType } from '@sifca-monorepo/ecommerce-generator';

@Component({
  template: '',
})
export class BaseIndexNewsletterComponent {
  posId: string = '';
  isButtonDisabled: boolean;
  newsLetterForm: FormGroup;
  newsletter$: Observable<SlidesType>;
  constructor(
    protected appService: AppService,
    protected formBuilder: FormBuilder,
    protected utilsService: UtilsService,
    protected toastrService: ToastrService,
    protected sharedService: SharedService,
    protected slidesService: SlidesService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    this.newsletter$ = this.slidesService.newsletter$;
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.newsLetterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    const initialValues = this.newsLetterForm.value;
    this.newsLetterForm.valueChanges.subscribe((ivalues) => {
      this.isButtonDisabled = isEqual(ivalues, initialValues);
    });
  }

  submitNewsLetter() {
    this.appService
      .addUserToNewsLetter(this.posId, this.newsLetterForm.value.email)
      .pipe(
        catchError(() => {
          this.toastrService.error("Quelque chose s'est mal passé");
          this.changeDetectorRef.markForCheck();
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.toastrService.success('NewsLetter submited Successfully.');
          this.isButtonDisabled = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
